import React from 'react';
import EditResultDisplay from './EditResultDisplay';
import moment from 'moment';
import { MdAssignment, MdSwapHoriz, MdAssessment } from 'react-icons/md';
import './ProvaSettings.css';

const enabled = value => value === true || value === 1 || value === '1' || value === 'true';
const answer = value => value == null ? 'Não informado' : enabled(value) ? 'Sim' : 'Não';

export default function ProvaSettings({ prova, processo, onUpdated }) {
  const objective = prova.type === 'multipla_escolha';
  const online = enabled(processo.online);
  const selection = enabled(prova.select_from_group) && enabled(prova.random_questions);
  const categories = prova.categorias_selecionadas || [];
  const presentation = enabled(prova.mirror)
    ? (enabled(prova.show_acertos) ? 'Caderno com gabarito e respostas do candidato' : 'Caderno de questões com gabarito')
    : enabled(prova.folha_resposta)
      ? (enabled(prova.show_acertos) ? 'Folha de resposta com relação de acertos/erros' : 'Folha de resposta do candidato')
      : enabled(prova.show_acertos) ? 'Relação de acertos/erros' : 'Nenhum conteúdo';
  const groups = [{
    title: 'Organização da prova', icon: MdAssignment, color: 'purple', rows: [
      ['Tipo de prova', objective ? 'Objetiva' : prova.type === 'dissertativa' ? 'Dissertativa' : 'Não informado'],
      ['Ordem das questões', prova.random_questions == null ? 'Não informado' : enabled(prova.random_questions) ? 'Aleatória' : 'Ordem de cadastro'],
      ...(objective ? [['Ordem das alternativas', prova.random_alternatives == null ? 'Não informado' : enabled(prova.random_alternatives) ? 'Aleatória' : 'Ordem de cadastro']] : []),
      ['Seleção de questões', selection ? 'Sorteio por candidato' : 'Todas as questões selecionadas'],
      ...(selection ? [
        ['Sorteio', enabled(prova.random_per_category) ? 'Independente da disciplina' : 'Por disciplina'],
        ...(enabled(prova.random_per_category) ? [['Questões por candidato', prova.number_select_questions ?? 'Não informado']] : []),
      ] : []),
      ...(enabled(processo.exam_per_time) ? [['Tempo por questão', prova.time == null ? 'Não informado' : `${prova.time} min`]] : []),
      ['Modelos de prova', enabled(prova.random_layouts_max) ? `${prova.number_exams ?? prova.provas?.length ?? 'Não informado'} modelos` : 'Sem número máximo definido'],
    ],
  }, ...(online ? [{
    title: 'Navegação do candidato', icon: MdSwapHoriz, color: 'cyan', rows: [
      ['Exibição das questões', enabled(prova.one_question_per_page) ? 'Uma questão por vez' : 'Todas em lista'],
      ...(enabled(prova.one_question_per_page) ? [
        ['Retornar à questão anterior', prova.block_return == null ? 'Não informado' : enabled(prova.block_return) ? 'Não permitido' : 'Permitido'],
        ...(enabled(prova.block_return) ? [['Avançar ao responder', answer(prova.auto_next_on_answer)]] : []),
      ] : []),
      ...(objective ? [['Mapa de respostas', prova.show_answer_map == null ? 'Visível' : enabled(prova.show_answer_map) ? 'Visível' : 'Oculto']] : []),
      ['Disciplina nas questões', enabled(prova.hide_category) ? 'Oculta' : 'Visível'],
      ...(objective && enabled(processo.need_pause) ? [['Bloquear alterações após pausa', answer(prova.block_return_after_pause)]] : []),
    ],
  }, {
    title: 'Ao finalizar a prova', icon: MdAssessment, color: 'green', rows: [
      ['Conteúdo exibido', presentation],
      ...(presentation !== 'Nenhum conteúdo' ? [
        ['Download do conteúdo', answer(prova.allow_result_download)],
        ['Disponível de', prova.result_release_starts_at ? moment(prova.result_release_starts_at).format('DD/MM/YYYY HH:mm') : 'Assim que finalizar'],
        ['Disponível até', prova.result_release_ends_at ? moment(prova.result_release_ends_at).format('DD/MM/YYYY HH:mm') : 'Sem data limite'],
      ] : []),
    ],
  }] : [])];

  return <section className="prova-settings" aria-label="Configurações da prova">
    <h2>Configurações da prova</h2>
    <div className="prova-settings-grid">
      {groups.map(group => {
        const Icon = group.icon;
        return <div className="prova-settings-group" key={group.title}>
          <h3><span className={`prova-settings-icon is-${group.color}`}><Icon aria-hidden="true" /></span>{group.title}</h3>
          {group.color === 'green' && onUpdated && <EditResultDisplay prova={prova} onUpdated={onUpdated} />}
          <dl>{group.rows.map(([label, value]) => <div className="prova-settings-row" key={label}><dt>{label}</dt><dd>{value}</dd></div>)}</dl>
          {group.color === 'purple' && selection && !enabled(prova.random_per_category) && categories.length > 0 && <div className="prova-settings-categories"><span>Questões por disciplina</span>{categories.map(category => <span className="prova-settings-category" key={category.id ?? category.categoria_id}>{category.categoria?.name || 'Disciplina'}<strong>{category.number ?? '—'}</strong></span>)}</div>}
        </div>;
      })}
    </div>
  </section>;
}
